import crossRefUrl from '../data/cross_references.txt';

const ABBR_TO_BOOK = {
  Gen: 'Genesis', Exod: 'Exodus', Lev: 'Leviticus', Num: 'Numbers',
  Deut: 'Deuteronomy', Josh: 'Joshua', Judg: 'Judges', Ruth: 'Ruth',
  '1Sam': '1 Samuel', '2Sam': '2 Samuel', '1Kgs': '1 Kings', '2Kgs': '2 Kings',
  '1Chr': '1 Chronicles', '2Chr': '2 Chronicles', Ezra: 'Ezra', Neh: 'Nehemiah',
  Esth: 'Esther', Job: 'Job', Ps: 'Psalms', Prov: 'Proverbs', Eccl: 'Ecclesiastes',
  Song: 'Song of Solomon', Isa: 'Isaiah', Jer: 'Jeremiah', Lam: 'Lamentations',
  Ezek: 'Ezekiel', Dan: 'Daniel', Hos: 'Hosea', Joel: 'Joel', Amos: 'Amos',
  Obad: 'Obadiah', Jonah: 'Jonah', Mic: 'Micah', Nah: 'Nahum', Hab: 'Habakkuk',
  Zeph: 'Zephaniah', Hag: 'Haggai', Zech: 'Zechariah', Mal: 'Malachi',
  Matt: 'Matthew', Mark: 'Mark', Luke: 'Luke', John: 'John', Acts: 'Acts',
  Rom: 'Romans', '1Cor': '1 Corinthians', '2Cor': '2 Corinthians', Gal: 'Galatians',
  Eph: 'Ephesians', Phil: 'Philippians', Col: 'Colossians',
  '1Thess': '1 Thessalonians', '2Thess': '2 Thessalonians',
  '1Tim': '1 Timothy', '2Tim': '2 Timothy', Titus: 'Titus', Phlm: 'Philemon',
  Heb: 'Hebrews', Jas: 'James', '1Pet': '1 Peter', '2Pet': '2 Peter',
  '1John': '1 John', '2John': '2 John', '3John': '3 John', Jude: 'Jude',
  Rev: 'Revelation',
};

// Parse "Gen.1.1" or "Prov.8.22-Prov.8.30" → { book, chapter, verse } (first ref of a range)
function parseRef(refStr) {
  const part = refStr.split('-')[0];
  const dots = part.split('.');
  if (dots.length < 3) return null;
  const book = ABBR_TO_BOOK[dots[0]];
  const chapter = parseInt(dots[1], 10);
  const verse = parseInt(dots[2], 10);
  if (!book || isNaN(chapter) || isNaN(verse)) return null;
  return { book, chapter, verse };
}

let _index = null;
let _promise = null;

// Lazy-load and parse the cross-reference TSV. Subsequent calls return the cached index.
export async function loadCrossRefIndex() {
  if (_index) return _index;
  if (_promise) return _promise;

  _promise = fetch(crossRefUrl)
    .then(r => r.text())
    .then(text => {
      const index = {};
      for (const line of text.split('\n')) {
        if (!line || line.startsWith('From') || line.startsWith('#')) continue;
        const parts = line.split('\t');
        if (parts.length < 3) continue;
        const from = parseRef(parts[0].trim());
        const to = parseRef(parts[1].trim());
        const votes = parseInt(parts[2], 10) || 0;
        if (!from || !to) continue;
        const key = `${from.book}-${from.chapter}-${from.verse}`;
        if (!index[key]) index[key] = [];
        index[key].push({ ...to, votes });
      }
      for (const key of Object.keys(index)) {
        index[key].sort((a, b) => b.votes - a.votes);
      }
      _index = index;
      return index;
    });

  return _promise;
}

// Returns top cross-references for a verse (sorted by votes, max 12).
export function getCrossRefs(index, book, chapter, verse) {
  if (!index) return [];
  return (index[`${book}-${chapter}-${verse}`] || []).slice(0, 12);
}

// Look up verse text from the loaded bibleData (book names are always English in JSON).
export function getVerseText(bibleData, book, chapter, verse) {
  const bookData = bibleData.find(b => b.name === book);
  if (!bookData) return null;
  const chapterData = bookData.chapters[chapter - 1];
  if (!chapterData) return null;
  return chapterData[verse - 1] || null;
}
